import { WithdrawStatusType, AdminWithdrawStatusType } from '@golden/gdk-base';
export const withdrawStatusMapAdminWithdrawStatus = {
    [WithdrawStatusType.IN_PROGRESS]: AdminWithdrawStatusType.IN_PROGRESS,
    [WithdrawStatusType.REVIEWING]: AdminWithdrawStatusType.REVIEWING,
    [WithdrawStatusType.SUCCESSFUL]: AdminWithdrawStatusType.SUCCESSFUL,
    [WithdrawStatusType.THIRD_PARTY_WITHDRAWING]: AdminWithdrawStatusType.THIRD_PARTY_WITHDRAWING,
    [WithdrawStatusType.REVIEW_FAIL]: AdminWithdrawStatusType.CANCEL,
    [WithdrawStatusType.THIRD_PARTY_PARTIAL_FAIL]: AdminWithdrawStatusType.THIRD_PARTY_WITHDRAW_FAIL,
    [WithdrawStatusType.CANCEL_THIRD_PARTY]: AdminWithdrawStatusType.IN_PROGRESS,
    [WithdrawStatusType.THIRD_PARTY_FAIL]: AdminWithdrawStatusType.THIRD_PARTY_WITHDRAW_FAIL,
    [WithdrawStatusType.THIRD_PARTY_HOOK_FAIL]: AdminWithdrawStatusType.THIRD_PARTY_WITHDRAW_FAIL,
    [WithdrawStatusType.THIRD_PARTY_DETAIL_HOOK_FAIL]: AdminWithdrawStatusType.THIRD_PARTY_WITHDRAW_FAIL,
    [WithdrawStatusType.CANCEL_BY_RE_PAYOUT]: AdminWithdrawStatusType.CANCEL,
    [WithdrawStatusType.FORWARDER_BALANCE_NOT_ENOUGH]: AdminWithdrawStatusType.THIRD_PARTY_WITHDRAW_FAIL,
    [WithdrawStatusType.NO_WAY_CAN_USE]: AdminWithdrawStatusType.THIRD_PARTY_WITHDRAW_FAIL,
    [WithdrawStatusType.AFTER_SPLITTING]: AdminWithdrawStatusType.THIRD_PARTY_WITHDRAWING
};
//# sourceMappingURL=withdrawStatusMapAdminWithdrawStatus.js.map